export default __webpack_public_path__ + "static/media/3.ab00c439.jpg";